import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Pingvinske vrste",
  "description": "",
  "published": "2007-06-10T00:00:00.000Z",
  "redirect_from": ["/blog/pingvinske-vrste/swizec/193"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Zadnje Äase se je nabiralo veliko stvari, ki bi jih bilo treba povedati, a zelo malo Äasa za poÄetje le-tega, tako da skušajmo to popraviti s prvo pripovedjo v kronološkem redosledu in potem druge v najkrajšem moÅ¾nem Äasu.`}</p>
    <p>{`V sredo sem nepopravljivo skvaril svoje raÄunalo in bolj ko sem ga skušal popraviti manj stvari je delovale. Iz teh kaotiÄno fatalnih razmer je zrasla moja odloÄitev. Spremenil bom okus pingvinov, ki upravljajo male zobnike v diferenÄnem stroju pod mojo mizo. Lotil sem se dolpotega Kubuntuja.`}</p>
    <p>{`Takoj sem opazil, da v osnovi delujoÄa inštalacija Kubuntuja traja le dobro uro ali dve v primerjavi z Getnoojevima dvema dnevoma. Kmalu sem tudi opazil kako hitro taista inštalacija raste in se debeli v nekaj bolj po moji meri, paketki so se nalagali in postavljali s prav všeÄno frekvenco.`}</p>
    <p>{`Nastavljanje mojega ATIja X1600 v dvoekranski naÄin je potekalo malÄek hitreje kot poprejšnjikat, okoli dve ure igraÄkanja, predvsem zaradi shranjenih konfiguracij od prej in verjetno nekaj izkušenj, ki so mi bile ostale. Naslednja stvar na agendi je bila nastavljanje zvoka na malo boljše performanse, v katerem trenutku je sovjo debelo grdo glavo pokazala najveÄja linuxova pomankljivost - ni preprostega naÄina za nastavljanje zvoka, sploh. Trenutno lahko, kot kaÅ¾e, izbirem med pravim dmixom ali 5.1 zvokom.`}</p>
    <p>{`NajveÄja teÅ¾ava, ki jo imam s Kubuntujem, je da iz nekega sumljivega razloga ni repozitorijih ni Opere, zakaj ne, ne vem. Velik problem je tudi teÅ¾aven postopek za usposabljanje mp3 in nasplošno multimedija podpore. ÄŒe je to neka distribucija za zaÄetnike, zakaj vraga je torej potrebnih toliko majÄkenih korakcov za dosego tistega kar naj bi vsako namizno raÄunalo zmoglo?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      